const { useEffect, useRef } = require("react");

const useFirstFocus = elemSelector => {
  const foucsElem = useRef(null);
  useEffect(() => {
    let tabClickCount = 0;
    function keydownHandler(event) {
      if (event.code === "Tab") {
        tabClickCount += 1;
        if (tabClickCount === 1) {
          event.preventDefault();
          if (elemSelector) {
            document.querySelector(elemSelector)?.focus();
          } else {
            foucsElem.current?.focus();
          }
        }
      }
    }
    document.addEventListener("keydown", keydownHandler);

    return () => {
      document.removeEventListener("keydown", keydownHandler);
    };
  }, []);
  return foucsElem;
};

export default useFirstFocus;
